// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1pwxA","search":"Settings_search__YEi_e","filter":"Settings_filter__WgJFT"};